import { ChartRangeOptionT, Periodicity } from 'types';

enum ChartBarsLimit {
  For24hours = 47,
  For1week = 167,
  For1month = 30,
}

export const options: ChartRangeOptionT[] = [
  {
    id: '24h',
    key: '24h',
    label: '24H',
    periodicity: Periodicity.Minute30,
    limit: ChartBarsLimit.For24hours,
  },
  {
    id: '1w',
    key: '1w',
    label: '1W',
    periodicity: Periodicity.Hour,
    limit: ChartBarsLimit.For1week,
  },
  {
    id: '1m',
    key: '1m',
    label: '1M',
    periodicity: Periodicity.Day,
    limit: ChartBarsLimit.For1month,
  },
];
